/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S1_HeadingInputs */

const tr_servis_s1_heading = /** @type {(inputs: Servis_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Genel`)
};

const en_servis_s1_heading = /** @type {(inputs: Servis_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. General`)
};

const de_servis_s1_heading = /** @type {(inputs: Servis_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Allgemeines`)
};

const ru_servis_s1_heading = /** @type {(inputs: Servis_S1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Общие положения`)
};

/**
* | output |
* | --- |
* | "1. General" |
*
* @param {Servis_S1_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s1_heading = /** @type {((inputs?: Servis_S1_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S1_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s1_heading(inputs)
	if (locale === "de") return de_servis_s1_heading(inputs)
	if (locale === "ru") return ru_servis_s1_heading(inputs)
	return tr_servis_s1_heading(inputs)
});